import { useCallback, useEffect, useRef, useState } from "react";
import style from "./MainPage.module.scss";

import { NavifationCard } from "../Card/NavigationCard";
import { ToBuySection } from "./Partials/ToBuy/ToBuy";

import { ColorSection } from "../../ColorContext";
import { About, ProperCare } from "../../AnchorContext";
import { Preview } from "../Article/Article";
import { ParallaxImage } from "../ParallaxImage";
import { getCards, useWindowSize } from "../../utils";
import { VideosSection } from "../VideoSection/VideoSection";

export const MainPage = () => {
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      document.querySelector(hash)?.scrollIntoView({
        behavior: "smooth",
      });
    }
  });
  return (
    <div>
      <HeroSection />
      <Border />
      <ArticlesSection />
      <Border />
      <VideosSection />
      <ToBuySection />
    </div>
  );
};

const HeroSection = () => {
  return (
    <About.Section className={style.main}>
      <ColorSection background="white" className={`${style.title} wrapper`}>

        <h1 className={style.title__text}>
          Стойкий иммунитет <br /> вашей машины
        </h1>
      </ColorSection>
      <div className={style.car}>
        <div className="wrapper">
          <div className={style.car__img}>
            <img src="/images/car.png" alt="car" />
          </div>
        </div>
      </div>
      <ColorSection background="white"  className={style.desc}>
        <div className="wrapper">
          <div className={style.desc__text}>
            Как защитить любимую машину от&nbsp;дождей, холодов, русской зимы,
            не&nbsp;всегда хороших дорог? Можно&nbsp;ли надолго сохранить
            ее&nbsp;здоровье и&nbsp;презентабельный внешний вид без помощи
            автосервисов, самостоятельно.
            <br />
            Ответ: да!
            <br />
            <br />
            Мы&nbsp;собрали самую подробную информацию по&nbsp;уходу
            за&nbsp;автомобилем - для тех, кто полагается только на&nbsp;себя
            и&nbsp;испытывает удовольствие, помогая ему выглядеть и&nbsp;ездить
            на&nbsp;все сто. Подарите вашей машине настоящий иммунитет!
          </div>
        </div>
      </ColorSection>
    </About.Section>
  );
};

const ArticlesSection = () => {
  const [showMore, setShowMore] = useState(false);
  const ref = useRef<HTMLElement>();
  const [cards, setCards] = useState<Preview[]>([]);
  const fetchCards = useCallback(async () => {
    const cards = await getCards();
    setCards(cards);
  }, []);
  useEffect(() => {
    fetchCards();
  }, [fetchCards]);
  const { width } = useWindowSize();
  const headerHeight = width && width > 770 ? 90 : 60;
  return (
    <ProperCare.Section ref={ref}>
      <ColorSection background={"#dff2ff"} className={style.articles}>
        <div className={`${style.articles__wrapper} wrapper`}>
          <div className={style["title-wrapper"]}>
            <div className={style.articles__title}>Правильный уход</div>
          </div>
          <div className={style.articles__cards}>
            {cards.slice(0, !showMore ? 5 : 10).map((card, i) => {
              const big = i === 2 || i === 5;
              const props = {
                content: <ParallaxImage src={card.preview + ".jpg"} alt="" />,
                title: card.title,
                description: card.description,
                id: card.id,
              };

              return <NavifationCard {...props} big={big} titleAsHtml label={card.label} />;
            })}
          </div>
          <div className={style.articles__button}>
            <button
              className={style.articles__button}
              onClick={() => {
                setShowMore((prev) => {
                  if (prev) {
                    const rect = ref.current?.getBoundingClientRect();
                    if (rect) {
                      const top =
                        rect.top + window.pageYOffset - (headerHeight - 4);
                      
                      requestAnimationFrame(() => {
                        window.scrollTo({ top, behavior: "smooth" });
                      });
                    }
                  }
                  return !prev;
                });
              }}
            >
              Показать {!showMore ? "больше" : "меньше"}
            </button>
          </div>
        </div>
      </ColorSection>
    </ProperCare.Section>
  );
};
const Border = () => {
  return (
    <div className={style['border-container']}>
      <div className={style['border-img']} />
    <div className={style.border}>
      <hr className="before-svg" />
      <img src="/images/border.svg" alt="" />
      <hr className="after-svg" />
    </div>
    </div>
  );
};
